
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 7 6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"var(--icon-success)","d":"m3.384 0 3.384 5.86H0z"}})])
          )
        }
      }
    